import { ADD_NEW_BOOK, DELETE_BOOKS, SELECT_FOR_UPDATE, SET_BOOKS, UPDATE_BOOK } from "./actionType";

const initialState = {
    books: [],
    selectForUpdate: {}
}
function createId(data) {
    return data.reduce((pre, current) => Math.max(pre, current.id), -1) + 1

}
const bookReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_BOOKS:
            return {
                ...state,
                books: action.payload,
            }
        case ADD_NEW_BOOK:
            // adding single book  
            const newBooks = { ...action.payload, id: createId(state.books) }
            return {
                ...state,
                books: [...state.books, newBooks]

            }
        case SELECT_FOR_UPDATE:
            return {
                ...state,
                selectForUpdate: action.payload,
            }
        case UPDATE_BOOK:
            const newUpdatedBooks = state.books.map(single => {
                if (single.id === action.payload.id) {
                    return {
                        ...action.payload
                    }
                }
                return single
            })
            return {
                ...state,
                books: newUpdatedBooks,
                selectForUpdate: {}
            }
        case DELETE_BOOKS:
            const filteredBooks = state.books.filter(single => single.id !== action.payload)
            return {
                ...state,
                books: filteredBooks
            }
        default:
            return state;
    }
}
export default bookReducer;